import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useDemoLaunch } from "@/context/DemoLaunchContext";
import { useLang } from "@/context/LanguageContext";
import { track } from "@/lib/analytics";

// "Experience it" goes straight into the real Public Demo (no intermediate showroom page).
export default function LaunchDemo() {
  const { startPublicDemo } = useAuth();
  const { beginLaunch, endLaunch } = useDemoLaunch();
  const { t } = useLang();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  const launch = async () => {
    setFailed(false);
    localStorage.setItem("ari_demo_tour_seen", "1");
    beginLaunch();
    track("demo_launched");
    for (let i = 0; i < 2; i += 1) {
      try {
        await startPublicDemo();
        navigate("/dashboard", { replace: true });
        return;
      } catch (e) { /* one automatic retry for a cold start */ }
    }
    endLaunch();
    setFailed(true);
  };

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    launch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0B] text-white flex items-center justify-center px-6" data-testid="launch-demo-page">
      {failed && (
        <div className="text-center" data-testid="launch-demo-error">
          <p className="text-white/70 mb-5">{t("Could not start the demo. Please try again.")}</p>
          <button type="button" onClick={launch} data-testid="launch-demo-retry"
            className="rounded-full px-6 py-3 text-sm font-medium text-[#1A1408]" style={{ background: "linear-gradient(100deg,#F6E3A6,#D4AF37)" }}>
            {t("Try again")}
          </button>
        </div>
      )}
    </div>
  );
}
